import Button from 'react-bootstrap/Button';

function UploadVehicleNumbersButton({ className, text, variant, ...props }) {
  return (
    <Button
      variant={variant ?? 'primary'}
      className={`d-flex bg-white text-black bg-opacity-75 align-items-center justify-content-center ${className}`}
      {...props}
    >
      <span
        className="material-symbols-outlined me-2"
        style={{ fontSize: '18px' }}
      >
        upload
      </span>
      {text}
    </Button>
  );
}

export default UploadVehicleNumbersButton;
